module.exports = __webpack_public_path__ + "static/media/class_03.13eb4c1c.jpg";